import { Component } from '@angular/core';

@Component({
	selector: 'app-maintenance',
	standalone: true,
	styleUrl: './maintenance.component.scss',
	templateUrl: './maintenance.component.html',
})
export class MaintenanceComponent {}
